import { Button, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { deleteClimbA } from '../../redux/climbs'

export const DeleteClimb = ({open, handleModal, climb_id, user, deleteClimb}) => {

const submitDelete = () => {
    deleteClimb(user, climb_id)
    handleModal(false)
}
  return (
    <Dialog open={open} onClose={() => handleModal()} aria-labelledby="form-dialog-title" >
        <DialogTitle>
            Voulez-vous vraiment supprimer cette ligne ?
        </DialogTitle>
        <DialogContent>
        <Grid container spacing={2} direction='row'>
            <Grid item>
                <Button
                    color='secondary'
                    variant='contained'
                    sx={{ maxWidth: '200px', backgroundColor: 'red' }}
                    onClick={submitDelete}
                >
                    Oui
                </Button>
            </Grid>
            <Grid item>
                <Button
                    color='secondary'
                    variant='contained'
                    sx={{ maxWidth: '200px' }}
                    onClick={() => handleModal(false)}
                >
                    Non
                </Button>
            </Grid>
        </Grid>
        </DialogContent>
    </Dialog>
  )
}

const mapStateToProps = (state) => ({
    user: state.user
})

const mapDispatchToProps = (dispatch) => ({
    deleteClimb: (user, climb_id) => dispatch(deleteClimbA(user, climb_id))
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteClimb)